// extracted by mini-css-extract-plugin
module.exports = {"navButton":"mobilenavbutton-module--navButton--W_yiR","mobile":"mobilenavbutton-module--mobile--2ueU-","desktop":"mobilenavbutton-module--desktop--3QHm0"};